import i18next from "i18next";
import * as React from "react";
import { useCallback } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import "./DragButton.scss";

const minHeight = 0;

export const DragButton = ({
    height,
    setHeight,
    setHeightPercent
}: {
    height: number;
    setHeight?: (height: number) => void;
    setHeightPercent?: (percent: number) => void;
}): JSX.Element => {
    const { isMobile, isIFrame } = useAppContext();
    const maxHeight = document.body.clientHeight;

    const onMouseDown = useCallback(
        (e) => {
            const startPos = e.clientY;
            const onMouseMove = (event: MouseEvent) => {
                const newHeight = height - event.clientY + startPos;
                setHeight(newHeight >= minHeight ? (newHeight >= maxHeight ? maxHeight : newHeight) : minHeight);
                // const heightPercentile = Math.round((100 * newHeight) / document.body.clientHeight);
                // setHeightPercent(heightPercentile >= 0 ? (heightPercentile >= 100 ? 100 : heightPercentile) : 0);
            };
            const onMouseUp = () => {
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
            };
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
        },
        [height, maxHeight, minHeight]
    );

    const onTouchStart = useCallback(
        (e) => {
            const startPos = e.touches[0].clientY;
            const onTouchMove = (event: TouchEvent) => {
                const newHeight = height - event.touches[0].clientY + startPos;
                setHeight(newHeight >= minHeight ? (newHeight >= maxHeight ? maxHeight : newHeight) : minHeight);
                // const heightPercentile = (100 * newHeight) / document.body.clientHeight;
                // setHeightPercent(heightPercentile >= 0 ? (heightPercentile >= 100 ? 100 : heightPercentile) : 0);
            };
            const onTouchUp = () => {
                document.removeEventListener("touchmove", onTouchMove);
                document.removeEventListener("touchend", onTouchUp);
            };
            document.addEventListener("touchmove", onTouchMove);
            document.addEventListener("touchend", onTouchUp);
        },
        [height, maxHeight, minHeight]
    );

    const button = (
        <div className="cv-drag-button">
            <span className="drag-line"></span>
            <svg height="16" width="30">
                <line x1="2" y1="3" x2="28" y2="3"></line>
                <line x1="2" y1="8" x2="28" y2="8"></line>
                <line x1="2" y1="13" x2="28" y2="13"></line>
            </svg>
        </div>
    );

    return isMobile && !isIFrame ? (
        <div className="cv-drag" onTouchStart={(e) => onTouchStart(e)} title={i18next.t("swipeHandlerTooltip")}>
            {button}
        </div>
    ) : (
        <div className="cv-drag" onMouseDown={(e) => onMouseDown(e)} title={i18next.t("swipeHandlerTooltip")}>
            {button}
        </div>
    );
};
